module.exports = "<button\r\n  type=\"button\"\r\n  class=\"ico-check m-btn m-btn-circle m-btn-circle-x-small\"\r\n  [ngClass]=\"getIcon().color\">\r\n  <i [ngClass]=\"getIcon().ico\"></i>\r\n</button>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/boolean-check/boolean-check.component.html
// module id = 2330
// module chunks = 66